export default {
      id: "expand-usage",
      viewBox: "0 0 20 20",
      url: "assets/" + "sprite.svg#expand-usage",
      toString: function () {
        return this.url;
      }
    }